import React from 'react';
import { Crosshair } from 'lucide-react';
import MapListToggle from '../MapListToggle';

interface MapControlsProps {
  pathname: string;
  isFindingLocation: boolean;
  onFindMe: () => void;
}

export const MapControls: React.FC<MapControlsProps> = ({
  pathname,
  isFindingLocation,
  onFindMe,
}) => {
  const isMapCampaign = pathname === '/map-campaign';

  if (!isMapCampaign) return null;

  return (
    <>
      <div className="fixed bottom-[5%] right-5 flex flex-col gap-3 z-50">
        <button
          onClick={onFindMe}
          disabled={isFindingLocation}
          className={`bg-white text-black p-3 rounded-full shadow-lg transition ${
            isFindingLocation
              ? 'opacity-50 cursor-not-allowed'
              : 'hover:bg-[#46B6D0] cursor-pointer'
          }`}
          aria-label="내 위치 찾기"
          title="내 위치로 이동"
        >
          {isFindingLocation ? (
            <div className="animate-pulse">
              <Crosshair size={24} />
            </div>
          ) : (
            <Crosshair size={24} />
          )}
        </button>
      </div>
      <MapListToggle />
    </>
  );
};